import { API_BASE_URL } from "../api/apiClient";

const PORTAL_BASE = "/api/v1/automap/dealer-portal";
const ADMIN_BASE = "/api/admin/automotive";

function templateUrl(scope) {
  if (scope === "admin") {
    return `${API_BASE_URL}${ADMIN_BASE}/inventory-imports/template`;
  }
  return `${API_BASE_URL}${PORTAL_BASE}/inventory-imports/template`;
}

export function downloadInventoryImportTemplate(scope = "dealer") {
  window.open(templateUrl(scope), "_blank", "noopener,noreferrer");
}

export function fetchDealerImports(dealerId) {
  return fetch(`${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/inventory-imports`, {
    credentials: "include",
  }).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "No se pudo cargar el historial.");
    return data;
  });
}

export function fetchDealerImport(dealerId, importId) {
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/inventory-imports/${encodeURIComponent(importId)}`,
    { credentials: "include" }
  ).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Importación no encontrada.");
    return data;
  });
}

export function uploadDealerImport(dealerId, formData) {
  return fetch(`${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/inventory-imports`, {
    method: "POST",
    credentials: "include",
    body: formData,
  }).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Error al subir el archivo.");
    return data;
  });
}

export function updateDealerImportMapping(dealerId, importId, fieldMapping) {
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/inventory-imports/${encodeURIComponent(importId)}/mapping`,
    {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fieldMapping }),
    }
  ).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Error al guardar mapeo.");
    return data;
  });
}

export function updateDealerImportRows(dealerId, importId, rows) {
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/inventory-imports/${encodeURIComponent(importId)}/rows`,
    {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ rows }),
    }
  ).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Error al actualizar filas.");
    return data;
  });
}

export function executeDealerImport(dealerId, importId) {
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/inventory-imports/${encodeURIComponent(importId)}/execute`,
    { method: "POST", credentials: "include" }
  ).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Error al ejecutar importación.");
    return data;
  });
}

export function dealerImportErrorsUrl(dealerId, importId) {
  return `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/inventory-imports/${encodeURIComponent(importId)}/errors.csv`;
}

export function fetchAdminImports(params = {}) {
  const qs = new URLSearchParams(params).toString();
  return fetch(`${API_BASE_URL}${ADMIN_BASE}/inventory-imports${qs ? `?${qs}` : ""}`, {
    credentials: "include",
  }).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "No se pudo cargar importaciones.");
    return data;
  });
}

export function fetchAdminImport(importId) {
  return fetch(`${API_BASE_URL}${ADMIN_BASE}/inventory-imports/${encodeURIComponent(importId)}`, {
    credentials: "include",
  }).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Importación no encontrada.");
    return data;
  });
}

export function uploadAdminImport(formData) {
  return fetch(`${API_BASE_URL}${ADMIN_BASE}/inventory-imports`, {
    method: "POST",
    credentials: "include",
    body: formData,
  }).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Error al subir el archivo.");
    return data;
  });
}

export function updateAdminImportMapping(importId, fieldMapping) {
  return fetch(`${API_BASE_URL}${ADMIN_BASE}/inventory-imports/${encodeURIComponent(importId)}/mapping`, {
    method: "PATCH",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ fieldMapping }),
  }).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Error al guardar mapeo.");
    return data;
  });
}

export function updateAdminImportRows(importId, rows) {
  return fetch(`${API_BASE_URL}${ADMIN_BASE}/inventory-imports/${encodeURIComponent(importId)}/rows`, {
    method: "PATCH",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ rows }),
  }).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Error al actualizar filas.");
    return data;
  });
}

export function executeAdminImport(importId) {
  return fetch(`${API_BASE_URL}${ADMIN_BASE}/inventory-imports/${encodeURIComponent(importId)}/execute`, {
    method: "POST",
    credentials: "include",
  }).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Error al ejecutar importación.");
    return data;
  });
}

export function adminImportErrorsUrl(importId) {
  return `${API_BASE_URL}${ADMIN_BASE}/inventory-imports/${encodeURIComponent(importId)}/errors.csv`;
}

export function trackImportEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[inventory-import-event]", eventType, metadata);
  }
}
